import Header from "components/Headers/Header";
import firebase from "firebase/app";
import debounce from "lodash.debounce";
import {
  Container,
  Table,
  Spinner,
  Button,
  Modal,
  ModalBody,
  Input,
  InputGroup,
  Card,
  ModalFooter,
  TabContent,
  TabPane,
  NavItem,
  Nav,
  NavLink,
  Row,
  Col,
} from "reactstrap";
import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { addContest } from "store/actions/contestAction";
import { getAthleteDataById } from "store/actions/athleteAction";
import { updateContestAthleteList } from "store/actions/contestAction";
import { getParticipantList } from "store/actions/contestAction";
import BrandAmbassadorContest from "components/BrandAmbassodarContest";
import { addType } from "store/actions/contestAction";
import contestImg from "../../assets/img/custom/contestImg.jpg";
import { toast } from "react-toastify";
import SportContest from "components/SportContest";
import TableComponent from "components/TableComponent";
import TabsInfoModal from "components/Modal/TabsInfoModal";

const Contest = () => {
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState(false);
  const [btnLoader, setBtnLoader] = useState(false);
  const [btnText, setBtnText] = useState("Add Athlete");
  const [dataLoader, setDataLoader] = useState(false);
  const [athleteList, setAthleteList] = useState([]);
  const [contestId, setContestId] = useState(null);
  const [addAthletemodal, setAddAthleteModal] = useState(false);
  const [contestYears, setContestYears] = useState(null);
  const [minEndDate, setMinEndDate] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [athleteListLoader, setAthleteListLoader] = useState(false);
  const [leaderBoardModal, setLeaderBoardModal] = useState(false);
  const [athleteModal, setAthleteModal] = useState(false);
  const [leaderBoardData, setLeaderBoardData] = useState(null);
  const [leaderBoardBtnLoader, setLeaderBoardBtnLoader] = useState(false);
  const [athleteData, setAthleteData] = useState(null);
  const [activeTab, setActiveTab] = useState("Sport Contest");
  const [formData, setFormData] = useState({
    sportName: "",
    ffSeason: "",
    startDate: null,
    endDate: null,
    contestType: "",
    gender: "",
  });
  const contestInfoPoints = [
    "The Sport Contest is created by the Organizer. The Admin can: Accept, or Reject the contest request.",
    "The Athlete Talent Contest is created by the Admin. The Admin is responsible for: Adding the final athletes to the contest. This action must be completed on the final date of the contest.",
  ];
  const subPoints = [
    {
      title: "Sport Contest",
      description: `The Sport Contest section includes the following sub-tabs: Contest Requests, Active Contests, Completed Contests. 
      The organizer submits a contest request to the Admin for running a contest on the FHP platform.
      The Admin can either: Accept, or Reject the request.`,
    },
    {
      title: "Contest Requests",
      description:
        "Shows all newly added contest requests submitted by organizers. Includes complete contest details. Admin responsibilities: Review each contest request. Accept or reject the request based on the information provided.",
    },
    {
      title: "Active Contest",
      description:
        "Contains all contests accepted by the Admin.  Admin has access to the following action buttons: View Details: Overview of enrolled schools, athletes, and fans. Add Athlete: Admin adds selected athlete(s) as final contenders. See Suggestions: Admin reviews athletes suggested by the organizer as potential final contenders.",
    },
    {
      title: "Completed Contest",
      description:
        "Contains all contests that have been completed. Admin has access to the same action buttons as in Active Contests:  View Details, Add Athlete, See Suggestions",
    },
    {
      title: "Athlete Talent Contest",
      description: `The Admin can create the Athlete Talent Contest. Before creating the contest, the Admin must:Select the contest type, which in this case is "Athlete Talent Contest".
      The maximum duration of the contest is one month.
      Once the contest begins, the Admin can monitor progress and results.  By clicking on "See Enroll Users", a modal window opens that displays: List of all participants. 
      Number of votes received by each contender.
      Which participants have qualified for the next level.
      Which participants have been eliminated from the contest.`,
    },
  ];

  const contestInfoTitle = "Contest Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const toggleTab = (tab) => {
    setActiveTab(tab);
  };
  const toggleAthleteModal1 = () => {
    setAthleteModal(!athleteModal);
  };
  const formatDate = (date) => {
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    return `${year}-${month}-${day}`;
  };

  const getDates = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;

    if (currentMonth < 7 || (currentMonth === 7 && currentDate.getDate() < 2)) {
      const date1 = new Date(currentYear, 6, 1);
      const date2 = new Date(currentYear + 1, 0, 2);
      return { date1: formatDate(date1), date2: formatDate(date2) };
    } else {
      const date1 = new Date(currentYear, 6, 1);
      const date2 = new Date(currentYear + 1, 6, 3);
      return { date1: formatDate(date1), date2: formatDate(date2) };
    }
  };

  const getCurrentYearAndNextFour = () => {
    const currentYear = new Date().getFullYear();
    const years = [currentYear];
    for (let i = 1; i <= 4; i++) {
      years.push(currentYear + i);
    }
    return years;
  };

  const removeAthlete = (athleteId) => {
    setAthleteList((prevAthleteList) =>
      prevAthleteList.filter((athlete) => athlete.athleteId !== athleteId)
    );
  };
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };
  const toggleAthleteModal = () => {
    setAddAthleteModal(!addAthletemodal);
  };
  const toggleLeaderBoardModal = () => {
    setLeaderBoardModal(!leaderBoardModal);
  };
  const addAthleteList = () => {
    const data = athleteList
      .map((athlete) => athlete.athlete_Id)
      .filter((id) => id !== undefined && id !== null);
    
    if (!contestId) {
      setBtnLoader(false);
      return;
    }
    
    if (data.length === 0) {
      toast.warning("No valid athletes to add");
      setBtnLoader(false);
      return;
    }
    
    dispatch(
      updateContestAthleteList(contestId, data, (msg) => {
        setBtnLoader(false);
        msg === "Success" && setAddAthleteModal(false);
      })
    );
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name == "startDate" || name == "endDate") {
      const timestamp = firebase.firestore.Timestamp.fromDate(new Date(value));
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
        [`${name}TimeStamp`]: timestamp,
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getNextDate = (dateString) => {
    const [year, month, day] = dateString.split("-").map(Number);
    const currentDate = new Date(year, month - 1, day);
    currentDate.setDate(currentDate.getDate() + 1);
    const nextYear = currentDate.getFullYear();
    const nextMonth = String(currentDate.getMonth() + 1).padStart(2, "0");
    const nextDay = String(currentDate.getDate()).padStart(2, "0");
    return `${nextYear}-${nextMonth}-${nextDay}`;
  };
  const [searchLoader, setSearchLoader] = useState(false);
  const handleAthleteSearch = useCallback(
    debounce(async (e) => {
      try {
        setSearchLoader(true);
        const inputVal = e.target.value;
        await dispatch(
          getAthleteDataById(
            Number(inputVal),
            contestId,
            (athleteData, isSuggested) => {
              setSearchLoader(false);
              if (athleteData) {
                if (!isSuggested) {
                  toast.warning("Athlete Not Suggested");
                  setInputValue("");
                  e.target.value = "";
                  return;
                }
                const newAthlete = {
                  athleteName:
                    athleteData.first_name + " " + athleteData.last_name,
                  athleteId: athleteData.athleteID,
                  athlete_Id: athleteData.id,
                };
                const exists = athleteList.some(
                  (athlete) => athlete.athleteId === athleteData.athleteID
                );
                if (!exists) {
                  setAthleteList((prevAthleteList) => [
                    ...prevAthleteList,
                    newAthlete,
                  ]);
                  toast.success("Athlete Get Successfully");
                } else {
                  toast.warning("Athlete Already Added");
                }
              } else {
                toast.warning("Athlete Not Found");
              }
              setInputValue("");
              e.target.value = "";
            }
          )
        );
      } catch (error) {
        console.error(error);
      }
    }, 3000),
    [athleteList, dispatch]
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    setBtnLoader(true);
    let data = null;
    if (formData.contestType === "Sport Contest") {
      data = {
        sportName: formData.sportName,
        ffSeason: formData.ffSeason,
        startDate: formData.startDateTimeStamp,
        endDate: formData.endDateTimeStamp,
        status: "accepted",
        contestType: formData.contestType,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        gender: formData.gender,
        total_buy_amount: 0,
      };
    } else {
      data = {
        startDate: firebase.firestore.Timestamp.fromDate(
          new Date(getDates().date1)
        ),
        endDate: firebase.firestore.Timestamp.fromDate(
          new Date(getDates().date2)
        ),
        status: "Kick-off",
        contestType: formData.contestType,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      };
    }

    dispatch(
      addContest(data, (msg) => {
        setBtnLoader(false);
        if (msg !== "error") {
          setModalOpen(false);
        }
      })
    );
  };

  const leaderBoardColumns = [
    "Fan Name",
    "Fan Email",
    "Total Points",
    "Athlete",
  ];
  const leaderBoardKeyMap = {
    "Fan Name": "fanName",
    "Fan Email": "email",
    "Total Points": "totalPoints",
  };

  // Define table configurations for Athletes
  const athleteColumns = ["Name", "Email", "ID"];
  const athleteKeyMap = {
    Name: "athleteName",
    Email: "email",
    ID: "athleteId",
  };

  // Render actions for LeaderBoard
  const renderLeaderBoardActions = (row) => (
    <Button
      color="primary"
      onClick={() => {
        setLeaderBoardBtnLoader(true);
        dispatch(
          getParticipantList(row.pointDetails, (data) => {
            if (data.length > 0) {
              setAthleteData(data);
              setAthleteModal(true);
            }
            setLeaderBoardBtnLoader(false);
          })
        );
      }}
    >
      {leaderBoardBtnLoader ? <Spinner size="sm" /> : "View"}
    </Button>
  );
  return (
    <>
      <Header />
      <Container fluid className="mb-5">
        <img src={contestImg} alt="" width="100%" className="mb-4" />
        {activeTab === "Brand Ambassador Contest" && (
          <div className="text-right">
            <Button
              color="primary"
              className="mt-2 mr-2"
              onClick={() => {
                if (!contestYears) {
                  setContestYears(getCurrentYearAndNextFour());
                }
                setMinEndDate(null);
                setFormData({
                  sportName: "",
                  ffSeason: "",
                  startDate: "",
                  endDate: "",
                  contestType: "",
                  gender: "",
                });
                setModalOpen(true);
              }}
            >
              Create/Add
            </Button>
          </div>
        )}
        <Row className="mb-5 mt-4">
          <Col sm="12">
            <Card className="pb-2">
              <Nav
                tabs
                className="d-flex justify-content-start text-dark athlete_earning-nav"
              >
                <NavItem>
                  <NavLink
                    className={
                      activeTab === "Sport Contest"
                        ? "active active-tab py-2 bg-primary "
                        : "text-dark cursor-pointer py-2 "
                    }
                    onClick={() => {
                      toggleTab("Sport Contest");
                    }}
                  >
                    <h2
                      className={
                        activeTab === "Sport Contest" ? "text-white" : ""
                      }
                    >
                      Sport Contest
                    </h2>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={
                      activeTab === "Brand Ambassador Contest"
                        ? "active active-tab py-2 bg-primary"
                        : "text-dark cursor-pointer py-2"
                    }
                    onClick={() => {
                      toggleTab("Brand Ambassador Contest");
                    }}
                  >
                    <h2
                      className={
                        activeTab === "Brand Ambassador Contest"
                          ? "text-white"
                          : ""
                      }
                    >
                      Athlete Talent Contest
                    </h2>
                  </NavLink>
                </NavItem>
                <h2
                  className="mb-0 ml-auto m-2 text-primary"
                  style={{ cursor: "pointer" }}
                  onClick={() => setInfoModalOpen(true)}
                >
                  <i className="fa fa-question-circle" aria-hidden="true"></i>
                </h2>{" "}
              </Nav>

              <>
                <TabContent
                  activeTab={activeTab}
                  className="p-4 athlete-earning-content"
                >
                  <TabPane tabId="Sport Contest">
                    <SportContest
                      contestId={contestId}
                      athleteList={athleteList}
                      setAthleteList={(data) => setAthleteList(data)}
                      setAthleteListLoader={(bool) =>
                        setAthleteListLoader(bool)
                      }
                      setAddAthleteModal={(data) => setAddAthleteModal(data)}
                      setLeaderBoardData={(data) => {
                        setLeaderBoardData(data);
                      }}
                      setLeaderBoardModal={(data) => setLeaderBoardModal(data)}
                      setContestId={(id) => setContestId(id)}
                    />
                  </TabPane>
                  <TabPane tabId="Brand Ambassador Contest">
                    <BrandAmbassadorContest
                      setAthleteList={(data) => setAthleteList(data)}
                      setAthleteListLoader={(bool) =>
                        setAthleteListLoader(bool)
                      }
                      setAddAthleteModal={(data) => setAddAthleteModal(data)}
                      setLeaderBoardData={(data) => {
                        setLeaderBoardData(data);
                      }}
                      setLeaderBoardModal={(data) => setLeaderBoardModal(data)}
                      setContestId={(id) => setContestId(id)}
                    />
                  </TabPane>
                </TabContent>
              </>
            </Card>
          </Col>
        </Row>
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={contestInfoPoints}
        title={contestInfoTitle}
        subPoints={subPoints}
      />
      <Modal isOpen={modalOpen} toggle={toggleModal} size="lg" centered>
        <h1 className="text-center mt-1 mb-0 p-3 pb-0 modal-title">
          ADD New Contest
        </h1>
        <ModalBody>
          <form
            onSubmit={handleSubmit}
            className="d-flex flex-wrap justify-content-center"
          >
            <Row className="w-100 no-gutters align-items-center mb-3">
              {/* Label */}
              <Col
                xs={12}
                md="auto"
                className="d-flex justify-content-start justify-content-md-end align-items-center mb-2 mb-md-0"
              >
                <label className="m-0 mr-md-2 text-center text-md-right">
                  Contest Type:
                </label>
              </Col>
              {/* Select Field */}
              <Col xs={12} md>
                <select
                  name="contestType"
                  className=" context_select w-100"
                  value={formData.contestType}
                  onChange={handleChange}
                  required
                >
                  <option value="" disabled>
                    Select Contest Type
                  </option>
                  <option value="Brand Ambassador Contest">
                    Athlete Talent Contest
                  </option>
                </select>
              </Col>
            </Row>

            <div className="formFields_container d-flex flex-column flex-wrap justify-content-center">
              <Row>
                {formData.contestType === "Sport Contest" && (
                  <Col md="6">
                    <div className="d-flex align-items-center mb-3">
                      <label className="m-0 mr-1">Sport Name: </label>
                      <select
                        name="sportName"
                        className="pl-2 context_select"
                        value={formData.sportName}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>
                          Select Sports
                        </option>
                        <option value="basketball">BasketBall</option>
                        <option value="football">FootBall</option>
                      </select>
                    </div>
                  </Col>
                )}
                {(formData.contestType === "Sport Contest" ||
                  formData.contestType === "Brand Ambassador Contest") && (
                  <Col lg="6">
                    <div className="d-flex align-items-center mb-3 mr-2">
                      <label
                        className="m-0 mr-1"
                        style={{ textWrap: "nowrap" }}
                      >
                        Start Date:{" "}
                      </label>
                      {formData.contestType === "Brand Ambassador Contest" ? (
                        <input
                          type="date"
                          className="p-2 context_input"
                          name="startDate"
                          value={getDates().date1}
                          disabled
                        />
                      ) : (
                        <input
                          type="date"
                          placeholder="Add Starting Date"
                          className="p-2 context_input"
                          name="startDate"
                          min={getCurrentDate()}
                          value={formData.startDate}
                          onChange={(e) => {
                            setMinEndDate(getNextDate(e.target.value));
                            handleChange(e);
                          }}
                          required
                        />
                      )}
                    </div>
                  </Col>
                )}
                {formData.contestType === "Sport Contest" && (
                  <Col md="6">
                    <div className="d-flex align-items-center mb-3 ml-2">
                      <label className="m-0 mr-1">FF Season: </label>
                      <select
                        name="ffSeason"
                        className="pl-2 context_select"
                        value={formData.ffSeason}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>
                          Select FF Season
                        </option>
                        {contestYears &&
                          contestYears.map((year, index) => (
                            <option key={index} value={`${year}-${year + 1}`}>
                              {year}
                            </option>
                          ))}
                      </select>
                    </div>
                  </Col>
                )}
                {(formData.contestType === "Sport Contest" ||
                  formData.contestType === "Brand Ambassador Contest") && (
                  <Col lg="6">
                    <div className="d-flex align-items-center mb-3 ml-2">
                      <label
                        className="m-0 mr-1"
                        style={{ textWrap: "nowrap" }}
                      >
                        End Date:{" "}
                      </label>
                      {formData.contestType === "Brand Ambassador Contest" ? (
                        <input
                          type="date"
                          className="p-2 context_input"
                          name="endDate"
                          disabled
                          value={getDates().date2}
                        />
                      ) : (
                        <input
                          type="date"
                          placeholder="Add End Date"
                          className="p-2 context_input"
                          name="endDate"
                          min={minEndDate}
                          disabled={!minEndDate}
                          value={formData.endDate}
                          onChange={handleChange}
                          required
                        />
                      )}
                    </div>
                  </Col>
                )}
                {formData.sportName === "basketball" && (
                  <Col md="6">
                    <label className="m-0 mr-1">Gender: </label>
                    <select
                      name="gender"
                      className="pl-2 context_select"
                      value={formData.gender}
                      onChange={handleChange}
                      required
                    >
                      <option value="" disabled>
                        Select Gender
                      </option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                    </select>
                  </Col>
                )}
              </Row>
            </div>

            <div className="formFields_container d-flex flex-column flex-wrap justify-content-center ml-3"></div>

            <div className="d-flex justify-content-center align-items-center mt-4 w-100">
              <button
                type="submit"
                disabled={btnLoader}
                className="btn btn-primary"
              >
                {btnLoader ? <Spinner size={"sm"} /> : "Add"}
              </button>
            </div>
          </form>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={addAthletemodal}
        toggle={toggleAthleteModal}
        size="lg"
        centered
      >
        <ModalBody>
          <InputGroup className="w-100  mb-3">
            <Row className="w-100 align-items-center no-gutters">
              <Col xs={12} md className="d-flex align-items-center">
                <Input
                  type="number"
                  className="flex-grow-1"
                  placeholder="Search Athlete By ID..."
                  onChange={(e) => {
                    handleAthleteSearch(e);
                  }}
                  disabled={athleteList.length == 88}
                />
                {searchLoader && (
                  <Spinner size="sm" className="ml-2" color="primary" />
                )}
              </Col>
            </Row>
          </InputGroup>
          {athleteListLoader ? (
            <div className="w-100 d-flex justify-content-center m-4">
              <Spinner size={"md"} />
            </div>
          ) : (
            <div className="d-flex flex-wrap">
              {athleteList.length > 0 ? (
                athleteList.map((athlete, index) => (
                  <div className="rounded-pill position-relative">
                    <i
                      className="fa fa-times-circle position-absolute close-circle"
                      onClick={() => {
                        removeAthlete(athlete.athleteId);
                      }}
                      aria-hidden="true"
                    ></i>
                    <span className="">{athlete.athleteName}</span>
                  </div>
                ))
              ) : (
                <div className="w-100 d-flex justify-content-center m-3">
                  Search An Athlete By Their Id
                </div>
              )}
              <div className="w-100 d-flex justify-content-end">
                <Button color="danger" onClick={toggleAthleteModal}>
                  Cancel
                </Button>
                <Button
                  id="block"
                  size="md"
                  color="primary"
                  className="btn"
                  disabled={athleteList.length == 0}
                  onClick={() => {
                    setBtnLoader(true);

                    addAthleteList();
                  }}
                >
                  {btnLoader ? (
                    <Spinner size={"sm"} />
                  ) : (
                    <>
                      <i className="fa fa-xmark"></i>
                      Add
                    </>
                  )}
                </Button>
              </div>
            </div>
          )}
        </ModalBody>
      </Modal>

      <Modal
        isOpen={leaderBoardModal}
        toggle={toggleLeaderBoardModal}
        size="lg"
        fullscreen
      >
        <ModalBody className="overflow-auto">
          <p className="custom-table-heading custom-heading">LeaderBoard</p>
          <TableComponent
            columns={leaderBoardColumns}
            data={leaderBoardData ? [leaderBoardData[0]] : []}
            keyMap={leaderBoardKeyMap}
            renderActions={renderLeaderBoardActions}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleLeaderBoardModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={athleteModal} toggle={toggleAthleteModal1} size="lg">
        <ModalBody className="overflow-auto">
          <p className="custom-table-heading custom-heading">Athletes</p>
          <Table>
            <thead>
              <tr>
                <th scope="col" className="custom-table-heading custom-heading">
                  Name
                </th>
                <th scope="col" className="custom-table-heading custom-heading">
                  Email
                </th>
                <th scope="col" className="custom-table-heading custom-heading">
                  ID
                </th>
              </tr>
            </thead>
            <tbody>
              {athleteData &&
                athleteData.map((athlete, index) => (
                  <tr key={index}>
                    <td>{athlete?.athleteName}</td>
                    <td>{athlete.email}</td>
                    <td>{athlete?.athleteId}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleAthleteModal1}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Contest;
